import React from "react";
import Receivables from "../../components/acesso-rapido/receivables/Receivables";

export default function () {
  return <Receivables />;
}
